///* eslint-disable */
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { generatePath } from 'react-router-dom';
import {
    Divider,
    Box,
    Typography,
    Checkbox,
    Button,
    Grid,
    //Switch,
    AppBar,
    Stack,
    FormControl,
    TextField,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormGroup,
} from '@mui/material';
import trash from '../../assets/images/trash.svg';
import IconPencil from '../../assets/images/Icon_Pencil.svg';
import { createState, useState, Downgraded } from '@hookstate/core';
import { updateModuleState } from '../../stores/eventStore';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import RouteConstants from '../../constants/routeConstants';
// import { useAuthState } from '../../stores/authStore';
// import shared components
import Title from '../../sharedcomponents/title/title';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ParticipantAutoList from '../../sharedcomponents/participantAutoList/participantAutoList';
import { useAgentState } from '../../hookState/AgentState';
import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import { FULL_PERMISSION, VIEW_PERMISSION } from '../../constants/Constant';
import { makeStyles } from '@mui/styles';
import AddGuest from './AddGuest';
import { RouterPrompt } from '../../router/routerPrompt';
import { isEmpty } from 'lodash-es';
import AppConstants from '../../constants/appConstants';
import PhoneNumber from '../../sharedcomponents/PhoneNumber/phoneNumber';
import dayjs from 'dayjs';

const appBarStyle = {
    mb: 1,
    boxShadow: 'none',
    pt: 1,
    pb: 1,
    pl: 1,
    borderTop: '1px solid #D7D7D7',
    borderBottom: '1px solid #D7D7D7',
    backgroundColor: '#F8F8F8',
};
const useStyles = makeStyles({
    mobileLogo: {
        height: 42,
    },
    sedanBlack: {
        height: 18,
        width: 36,
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
});
const eventState = createState({
    firstName: '',
    lastName: '',
    email: '',
    contactNo: '',
    eventForm: null,
    alternateContactName: '',
    alternateContactNo: '',
    alternateContactEmail: '',
    agentProDayParticipant: false,
    registrationID: 0,
    addedFor: 0,
    guestList: [],
    lunchGuestList: [],
    hometown:'',
    regState:'',
    country:'',
    university:'',
    pronunciationNotes:'',
    greenRoomGuest1Name:'',
    greenRoomGuest2Name:'',
    greenRoomGuest1Relation:'',
    greenRoomGuest2Relation:'',
    
});
const DraftRegistration = (props) => {
    const classes = useStyles();
    const state = useState(eventState);
    const loading = useState(false);
    // const authState = useAuthState();
    const agentState = useAgentState();
    const greenRoomGuest = useState(0);
    const greenRoomTag = useState('');
    const greenRoomSelf = useState(0);
    const showGreenRoomGuest = useState(false);
    const greenRoomTitleText = useState('Green Room Table');    
    const lunchGuests = useState(0);
    const isPreDraftPicture = useState(false);
    const greenRoomGuestsText = useState('')
    const draftAnnouncementInfoText = useState('')
    const lunchRoomGuestsText = useState('');
    const preDraftPic = useState(2);
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    const dirty = useState(false);
    const regex = new RegExp('[^\\s]+');
    // const tags = Helper.getStorage('userTags');
    const [eventTags, setEventTags] = React.useState([]);
    const moduleIndex = useState(-1);
    const [emailErr, setEmailErr] = React.useState('');
    const [altEmailErr, setAltEmailErr] = React.useState('');
    const [phoneError, setPhoneError] = React.useState('');
    const [altPhoneError, setAltPhoneError] = React.useState('');
    const [participantList, setParticipantList] = React.useState(null);
    const [isParticipant, setIsParticipant] = React.useState(false);
    const [firstNameErr, setFirstNameErr] = React.useState('');
    const [altNameErr, setAltNameErr] = React.useState('');  
    const [hometownErr, setHomeTownErr] = React.useState('');
    const [stateErr, setStateErr] = React.useState('');
    const [countryErr, setCountryErr] = React.useState('');
    const [universityErr, setUniversityErr] = React.useState('');
    const [greenRoomGuest1NameErr, setGreenRoomGuest1NameErr] = React.useState('');
    const [greenRoomGuest1RelationErr, setGreenRoomGuest1RelationErr] = React.useState('');
    const [greenRoomGuest2NameErr, setGreenRoomGuest2NameErr] = React.useState('');
    const [greenRoomGuest2RelationErr, setGreenRoomGuest2RelationErr] = React.useState('');

    
    const [lasttNameErr, setLastNameErr] = React.useState('');
    const [checkEditPermission, setCheckEditPermission] = React.useState(true);
    // const [showAgentProParticipant, setShowAgentProParticipant] = React.useState(false);
    const openGuestDialog = useState(false);
    const openLunchGuestDialog = useState(false);
    const stateGuestObj = useState(null);
    const stateLunchGuestObj = useState(null);
    const [participant, setParticipant] = React.useState(null);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    // const prevState = useState(null);
    let params = useParams();
    // const userEvents = Helper.getStorage('UserEvents');
    const [disableBtn, setDisableBtn] = React.useState(true);
    // const userInfo = Helper.getStorage('userInfo');
    // const eventInfo = Helper.getStorage('eventInfo');
    let eventRole = '';
    if (!isEmpty(eventInfo)) {
        eventRole =
            userInfo && userInfo.roles
                ? userInfo.roles.find(
                    (item) => item.eventID === eventInfo.eventID
                )?.eventRole
                : '';
    }
    useEffect(() => {
        getParticipantList();
        getEventConfig()
        ApiHelper.get(APIURLConstants.GET_TAGS(eventInfo.eventID))
            .then((res) => {
                setEventTags(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
        return () => {
            resetState(true);
        };
    }, []);
    const getEventConfig = () => {
        ApiHelper.get(
            APIURLConstants.GET_EVENT_CONFIG(eventInfo.eventID)
        ).then((res) => {

            if (res.data && res.data.length > 0) {
                res.data.map((data) => {
                    if (data.key === "GreenRoomGuests" && data.moduleName === "DraftRegistration") {
                        greenRoomGuest.set(Number(data.description));
                    }
                    if (data.key === "UserTags" && data.moduleName === "DraftRegistration") {
                        greenRoomTag.set(data.description);
                    }
                    if (data.key === "GreenRoomSelf" && data.moduleName === "DraftRegistration") {
                        greenRoomSelf.set(Number(data.description));
                    }
                    if (data.key === "GreenRoomTitle" && data.moduleName === "DraftRegistration") {
                        greenRoomTitleText.set(data.description);
                    }
                    // if (data.key === "UserTags" && data.moduleName === "DraftRegistration" && data.description === "GreenRoom") {
                    //     showGreenRoomGuest.set(true);
                    // } 
                    if (data.key === "LunchRoomGuests" && data.moduleName === "DraftRegistration") {
                        lunchGuests.set(Number(data.description));
                    }
                    if (data.key === "PreDraftPicture" && data.moduleName === "DraftRegistration") {
                        preDraftPic.set(Number(data.description));
                    }
                    if (data.key === "IsPreDraftPicture" && data.moduleName === "DraftRegistration") {
                        isPreDraftPicture.set(Number(data.description) === 0 ? false : true);
                    }
                    if (data.key === "GreenRoomGuestsText" && data.moduleName === "DraftRegistration") {
                        greenRoomGuestsText.set(data.description);
                    }
                    
                    if (data.key === "DraftAnnouncementInfoText" && data.moduleName === "DraftRegistration") {
                        draftAnnouncementInfoText.set(data.description);
                    }
                    
                    if (data.key === "LunchRoomGuestsText" && data.moduleName === "DraftRegistration") {
                        lunchRoomGuestsText.set(data.description);
                    }

                })
            }
            // console.log("res",res.data);

        });
    }
    // console.log("isPreDraftPicture",isPreDraftPicture.get());
    // useEffect(() => {
    //     // const authStateInfo = authState
    //     //     .nested('appDetails')
    //     //     .attach(Downgraded)
    //     //     .get();
    //     // if (
    //     //     authStateInfo &&
    //     //     authStateInfo.greenRoomGuests &&
    //     //     authStateInfo.greenRoomGuest !== 0 &&
    //     //     greenRoomGuest.get() === 0
    //     // ) {
    //     //     greenRoomGuest.set(authStateInfo.greenRoomGuests);
    //     // }
    //     // if (
    //     //     authStateInfo &&
    //     //     authStateInfo.lunchGuests &&
    //     //     authStateInfo.lunchGuests !== 0 &&
    //     //     lunchGuests.get() === 0
    //     // ) {
    //     //     lunchGuests.set(authStateInfo.lunchGuests);
    //     // }
    //     // if (
    //     //     authStateInfo &&
    //     //     authStateInfo.preDraftPicture &&
    //     //     authStateInfo.preDraftPicture !== 0 &&
    //     //     preDraftPic.get() !== authStateInfo.preDraftPicture
    //     // ) {
    //     //     preDraftPic.set(authStateInfo.preDraftPicture);
    //     // }
    // }, [authState]);
    useEffect(() => {

        if (props.modPermission) {
            if (props.modPermission == FULL_PERMISSION) {
                setCheckEditPermission(true);
            } else if (props.modPermission == VIEW_PERMISSION) {
                setCheckEditPermission(false);
            } else {
                setCheckEditPermission(false);
            }
            getModuleDetailsData(props.eventStateDetail.eventDetail);
        }
    }, [props]);

    const getModuleDetailsData = (eventDetail) => {
        if (eventDetail?.moduleDetails) {
            const index = eventDetail.moduleDetails.findIndex((element) => {
                if (element.moduleName === 'DraftRegistration') {
                    return true;
                }
            });
            //setShowAgentProParticipant(eventDetail.moduleDetails[index].showAgentProDayParticipant)
            if (!Helper.isAdminUser(userInfo)) {
                moduleIndex.set(index);
            }
        }
    };
    // useEffect(() => {
    //     if (!Helper.isAdminUser(userInfo)) {
    //         console.log("hello")
    //         const gAgentInfo = Helper.getStorage('agentUser');
    //         const agentConnection = Helper.getStorage('agentConnections');
    //         ApiHelper.get(
    //             APIURLConstants.GET_EVENT_DRAFT_REGISTRATION_INFO(
    //                 eventInfo.eventID,
    //                 agentConnection && gAgentInfo
    //                     ? gAgentInfo.userID
    //                     : userInfo.userID
    //             )
    //         ).then((res) => {
    //             if (res.data) {
    //                 let users = res.data;
    //                 prevState.set(users);
    //                 console.log(users)
    //             } else if (props != undefined && props.data) {
    //                 prevState.set(props.data);
    //                 console.log(props.data)
    //             }
    //         });
    //     } else {
    //         console.log("hi")
    //         if (params && params.registrationID)
    //             ApiHelper.get(
    //                 APIURLConstants.GET_EVENT_DRAFT_REGISTRATION(
    //                     params.registrationID
    //                 )
    //             ).then((res) => {
    //                 if (res.data) {
    //                     prevState.set(res.data);
    //                 }
    //             });
    //     }
    // }, []);
    useEffect( () => {
        
        const fetchdata = async () => {
            if (props.asAdmin) {
                resetState(true);
            }
            // console.log('--------->', props.data);
            // console.log(props)
            if (props.data) {
                const userData = props.data;

                let eventJson = null;

                state.firstName.set(userData.firstName);
                state.lastName.set(userData.lastName);
                state.email.set(userData.email);
                state.contactNo.set(userData.contactNo ? userData.contactNo : '');

                state.alternateContactName.set(
                    userData.alternateContactName
                        ? userData.alternateContactName
                        : ''
                );
                state.alternateContactNo.set(
                    userData.alternateContactNo ? userData.alternateContactNo : ''
                );
                state.alternateContactEmail.set(
                    userData.alternateContactEmail
                        ? userData.alternateContactEmail
                        : ''
                );

                state.agentProDayParticipant.set(userData.agentProDayParticipant);
                state.registrationID.set(
                    userData.registrationID ? userData.registrationID : 0
                );
                state.hometown.set(userData.hometown && userData.hometown ? userData.hometown : "")
                state.regState.set(userData.state && userData.state ? userData.state : "")
                state.country.set(userData.country && userData.country ? userData.country : "")
                state.university.set(userData.university && userData.university ? userData.university : "")
                state.pronunciationNotes.set(userData.pronunciationNotes)
                state.guestList.set(
                    userData.guestList
                        ? userData.guestList
                        : greenRoomSelf.get() !== 0
                            ? [
                                {
                                    name: `${userData.lastName} ${userData.firstName}`,
                                    relationship: 'Self',
                                    preDraftPicture: false,
                                },
                            ]
                            : []
                );
                state.greenRoomGuest1Name.set(userData.guestList && userData.guestList.length > 0 ? userData.guestList[0].name :"")
                state.greenRoomGuest1Relation.set(userData.guestList && userData.guestList.length > 0 ? userData.guestList[0].relationship:"")
                state.greenRoomGuest2Name.set(userData.guestList && userData.guestList.length > 0 ? userData.guestList[1].name:"")
                state.greenRoomGuest2Relation.set(userData.guestList && userData.guestList.length > 0 ? userData.guestList[1].relationship:"")
                state.lunchGuestList.set(
                    userData.lunchGuestList
                        ? userData.lunchGuestList
                        : greenRoomSelf.get() !== 0
                            ? [
                                {
                                    name: `${userData.lastName} ${userData.firstName}`,
                                    relationship: 'Self',
                                    preDraftPicture: false,
                                },
                            ]
                            : []
                );
                state.addedFor.set(userData.addedFor);
                if (userData.addedFor && props.participantList) {
                    const index = props.participantList.findIndex(
                        (user) => user.userID == userData.addedFor
                    );
                    if (index > -1) {
                        setParticipant(props.participantList[index]);
                        eventJson = await getEventJSON(
                            props.participantList[index]
                        );
                    }
                } else {
                    eventJson = await getEventJSON(userData);
                }

                const eventForm = userData.eventForm
                    ? JSON.parse(userData.eventForm)
                    : eventJson;
                if (eventForm) {
                    state.eventForm.set(eventForm);
                }
            }else{ 
                // if(userInfo?.tags && userInfo?.tags !== null){
                //     userInfo.tags.map((val) => {
                //         if(val.eventID === eventInfo.eventID){
                //             userInfo.userTags = val.userTags
                //         }
                //     })
                // }
                const newUserInfo = participantList && participantList.length > 0 && participantList.filter((val) => 
                    val.userID === userInfo.userID
                )
                // console.log("userInfo",userInfo, "participantList",participantList, newUserInfo);
                if(newUserInfo && newUserInfo.length > 0){
                    let formJSON = await getEventJSON(newUserInfo[0]);
                    state.eventForm.set(formJSON ?? null);
                }
                
             }
        }
        fetchdata();
        // console.log("userInfo123",userInfo);
        getEventGreenRoomConfig()
    }, [props.data]);
    const getEventGreenRoomConfig = () => {  
        if (userInfo && !(Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)) ||
            (userInfo.roles && Helper.isEventStaff(userInfo)))) {
                // console.log("userInfo",userInfo);
            if (userInfo && userInfo.userTags && userInfo.userTags.length > 0) {
                const splitTags = userInfo.userTags && userInfo.userTags.split(',');
                // console.log("splitTags", splitTags);
        
                if (splitTags && splitTags.length > 0) {
                    for (var i = 0; i < splitTags.length; i++) {
                        if (splitTags[i].trim() === greenRoomTag.get()) {
                            showGreenRoomGuest.set(true)
                            break
                        } else {
                            showGreenRoomGuest.set(false)
                        }
                    }
                }
            }
            if (userInfo && userInfo.tags && userInfo.tags.length > 0) {
                userInfo.tags.map((vals) => {
                    if (vals.eventID === eventInfo.eventID) {
                        const splitTags = vals.userTags && vals.userTags.split(',');
                        // console.log("splitTags", splitTags);
                
                        if (splitTags && splitTags.length > 0) {
                            for (var i = 0; i < splitTags.length; i++) {
                                if (splitTags[i].trim() === greenRoomTag.get()) {
                                    showGreenRoomGuest.set(true)
                                    break
                                } else {
                                    showGreenRoomGuest.set(false)
                                }
                            }
                        }
                    }
                })
            }       
        }
        
    }
    const resetState = (flag) => {
        setFirstNameErr('');
        setLastNameErr('');
        setPhoneError('');
        setEmailErr('');
        setAltNameErr('');
        setAltEmailErr('');
        setAltPhoneError('');
        setHomeTownErr('')
        setStateErr('')
        setCountryErr('')
        setUniversityErr('')
        setGreenRoomGuest1NameErr('')
        setGreenRoomGuest1RelationErr('')
        setGreenRoomGuest2NameErr('')
        setGreenRoomGuest2RelationErr('')
        state.set({
            firstName: agentState.visible.value ? userInfo.firstName : '',
            lastName: agentState.visible.value ? userInfo.lastName : '',
            email: agentState.visible.value ? userInfo.email : '',
            dob: null,
            contactNo: '',
            eventForm: null,
            alternateContactName: '',
            alternateContactNo: '',
            alternateContactEmail: '',
            agentProDayParticipant: false,
            registrationID: flag ? 0 : state.registrationID.get(),
            addedFor: flag ? 0 : state.addedFor.get(),
            guestList: [],
            lunchGuestList: [],
            hometown:'',
            regState:'',
            country:'',
            university:'',
            pronunciationNotes:'',
            greenRoomGuest1Name:'',
            greenRoomGuest2Name:'',
            greenRoomGuest2Relation:'',
            greenRoomGuest1Relation:''
        });
    };
    // const isValidForm = () => {
    //     const selectedState = state.get();
    //     let isValid = true;
    //     if (selectedState.firstName === null || firstNameErr.length > 0 || selectedState.firstName?.trim()?.length == 0) {
    //         setFirstNameErr('Please Enter Valid Name')
    //         isValid = false;
    //     }

    //     if (selectedState.lastName === null || lasttNameErr.length > 0 || selectedState.lastName?.trim()?.length == 0) {
    //         setLastNameErr('Please Enter Valid Name')
    //         isValid = false;
    //     }

    //     if (selectedState.email === null || emailErr.length > 0 || selectedState.email?.trim()?.length == 0) {
    //         setEmailErr('Please Enter Valid Email')
    //         isValid = false;
    //     }

    //     if ((selectedState.contactNo === null || phoneError.length > 0 || selectedState.contactNo?.trim()?.length == 0)) {
    //         setPhoneError('Please Enter Valid Contact Number')
    //         isValid = false;
    //     }

    //     if ((selectedState.alternateContactName === null || altNameErr.length > 0 || selectedState.alternateContactName?.trim()?.length == 0)) {
    //         setAltNameErr('Please Enter Valid Name')
    //         isValid = false;
    //     }

    //     if ((selectedState.alternateContactNo == null || altPhoneError.length > 0 || selectedState.alternateContactNo?.trim()?.length == 0)) {
    //         setAltPhoneError('Please Enter Valid Contact Number')
    //         isValid = false;
    //     }
    //     if ((selectedState.alternateContactEmail == null || altEmailErr.length > 0 || selectedState.alternateContactEmail?.trim()?.length == 0)) {
    //         setAltEmailErr('Please Enter Valid Email')
    //         isValid = false;
    //     }

    //     return isValid;
    // }
    const getParticipantList = () => {
        
        if (
            Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))
        ) {
            setIsParticipant(true)
        }
        ApiHelper.get(
            APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(eventInfo.eventID)
        ).then((res) => {
            if (res.data.rows) {
                const participants = res.data.rows.filter(
                    (participant) =>
                        AppConstants.EVENT_ROLES_VALUES.indexOf(
                            participant.roleName
                        ) == -1
                );
                setParticipantList(participants);
            }
        });
    };
    const handleClick = (event) => {
        event.preventDefault();
        loading.set(true);
        
        const selectedState = state.get();
        let selectedValues = [];
        if (selectedState.eventForm && selectedState.eventForm !== null) {
            selectedState.eventForm?.FormFields?.forEach((item) => {
                selectedValues = selectedValues.concat(
                    item.filter((x) => x.FieldValue).map((y) => y.FieldName)
                );
            });
        }
        
        let isvalid = true;
        if (
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                ?.FormFields[0].find(
                    (x) => x.FieldValue === true && x.FieldName !== 'NotAttend'
                ) &&
            selectedState.alternateContactNo === ''
        ) { 
            setAltPhoneError('Please enter alternate Contact number');
            isvalid = false;
        }else{
            setAltPhoneError('');
            isvalid = true;
        }
        if (!validateFirstName()) {
            isvalid = false;
        }
        if (!validatelastName()) {
            isvalid = false;
        }
        if (selectedState.contactNo === '') {
            setPhoneError('Please enter Contact number');
            isvalid = false;
        }
        if (phoneError.length > 0) {
            isvalid = false;
        }

        if (!ValidateEmail()) {
            isvalid = false;
        }
        if (!validateAltName()) {
            isvalid = false;
        }
        
        if (!ValidateAlternateEmail()) {
            isvalid = false;
        } 
        if (altPhoneError.length > 0) {
            isvalid = false;
        }

        // if (selectedState.email == props.data.email)
        // {
        //     setEmailErr('This email already exists');
        //     return false;
        // }
        if (
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                ?.FormFields[0].find(
                    (x) => x.FieldValue === true && x.FieldName !== 'NotAttend'
                )  
        ) {
            if (!validateHometown()) {
                isvalid = false;
            }
            if (!validateState()) {
                isvalid = false;
            }
            if (!validateCountry()) {
                isvalid = false;
            }
            if (!validateUniversity()) {
                isvalid = false;
            }
            if(showGreenRoomGuest.get()){
                if (!validateGreenRoomGuest1Name()) {
                    isvalid = false;
                }
                if (!validateGreenRoomGuest2Name()) {
                    isvalid = false;
                }
                if (!validateGreenRoomGuest1Relation()) {
                    isvalid = false;
                }
                if (!validateGreenRoomGuest1Relation()) {
                    isvalid = false;
                }
            }            
        }
        if (!isvalid) {
            loading.set(false);
            return false;
        } else if (
            (selectedState.eventForm === null &&
                selectedValues.join(', ') === '') ||
            (selectedState.eventForm !== null &&
                selectedValues.join(', ') !== '' &&
                selectedValues.length ===
                selectedState.eventForm?.FormFields?.length)
        ) {
            state.isDisable.set(true);
            const eventInfo = Helper.getStorage('eventInfo');
            const gUserInfo = Helper.getStorage('userInfo');

            let checkboxObj =
                selectedState.eventForm !== null
                    ? JSON.stringify(selectedState.eventForm)
                    : null;
            // let guestList = selectedState.guestList.map((x) => {
            //     return {
            //         name: x.name,
            //         relationship: x.relationship,
            //         preDraftPicture: x.preDraftPicture,
            //     };
            // });
            let guestList =   [{
                    name: state.greenRoomGuest1Name.get(),
                    relationship: state.greenRoomGuest1Relation.get(),                     
                },{
                    name: state.greenRoomGuest2Name.get(),
                    relationship: state.greenRoomGuest2Relation.get(),                     
                }]
            let lunchGuestList = selectedState.lunchGuestList.map((x) => {
                return { name: x.name, relationship: x.relationship };
            });
            let Obj = {
                registrationID: selectedState.registrationID,
                eventID: eventInfo.eventID,
                firstName: selectedState.firstName.trim(),
                lastName: selectedState.lastName.trim(),
                contactNo: selectedState.contactNo,
                email: selectedState.email,
                alternateContactName: selectedState.alternateContactName
                    .trim()
                    .replace(/\s\s+/g, ' '),
                alternateContactNo: selectedState.alternateContactNo ? selectedState.alternateContactNo == "+1" ? "" : selectedState.alternateContactNo : "",
                alternateContactEmail: selectedState.alternateContactEmail,
                agentProDayParticipant: selectedState.agentProDayParticipant,
                eventForm: checkboxObj,
                guestList:  showGreenRoomGuest.get() ? guestList : [],
                lunchGuestList: lunchGuestList,
                // addedFor: participant
                //     ? participant.userID
                //     : selectedState.addedFor
                //     ? selectedState.addedFor
                //     : userInfo.userID,
                addedFor: agentState.visible.value
                    ? agentState.user.get() && agentState.user.get().userID
                    : participant
                        ? participant.userID
                        : selectedState.addedFor
                            ? selectedState.addedFor
                            : userInfo.userID,
                createdBy: gUserInfo.userID,
                hometown: selectedState.hometown,
                state: selectedState.regState,
                country: selectedState.country,
                university: selectedState.university,
                pronunciationNotes: selectedState.pronunciationNotes,
            };
            // console.log('obj', Obj);

            ApiHelper.post(APIURLConstants.POST_DRAFT_REGISTRATION_INFO, Obj)
                .then(async (res) => {
                    dirty.set(false);
                    if (res.status === 200) {
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Form submitted successfully',
                        });
                        setDisableBtn(true);
                        let selectedOption = [];
                        if (selectedState.eventForm !== null) {
                            selectedState.eventForm.FormFields.forEach(
                                (item) => {
                                    if (item.find((x) => x.FieldValue)) {
                                        selectedOption.push(
                                            item.find((x) => x.FieldValue)
                                                .Description
                                        );
                                    }
                                }
                            );
                        }
                        let isPublished = participantList.filter(
                            (x) =>
                                x.isPublished === true &&
                                x.userID === Obj.addedFor
                        );
                        // if (isPublished.length > 0) {
                        //     SETEmailNotification({
                        //         ...Obj,
                        //         eventForm: selectedOption.join(', '),
                        //         dob: dayjs(Obj.dob).format('YYYY-MM-DD'),
                        //     });
                        // }
                        await updateModuleState();
                        setTimeout(() => {
                            state.isDisable.set(false);
                            if (props.asAdmin) {
                                resetState(true);

                                props.history.push({
                                    pathname: generatePath(
                                        RouteConstants.EVENT_DRAFT_REGISTRATION_LIST,
                                        { eventID: eventInfo.eventID }
                                    ),
                                });
                            } else {
                                props.history.push(
                                    generatePath(RouteConstants.EVENT_DETAIL, {
                                        eventID: eventInfo.eventID,
                                    })
                                );
                            }
                            // loading.set(false);
                        }, 1000);
                    }
                })
                .catch((error) => {
                    console.log('error : ', error);
                    loading.set(false);
                    state.isDisable.set(false);
                    let message = '';
                    if (error.response && error.response.status === 401) {
                        message = 'Access denied';
                    } else {
                        message = 'Error while Adding Registration';
                    }
                    setSnackBarProps({
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                    // props.handleClose();
                    // props.getParticipants();
                });
        } else if (
            selectedState.eventForm !== null &&
            selectedValues.length !==
            selectedState.eventForm?.FormFields?.length
        ) {
            loading.set(false);
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select all options.',
            });
            return;
        }
    };

    const checkValidPhone = (val) => {
        state.contactNo.set(val);
        handleDisableBtn();
        const phone = state.contactNo.get() ?? '';
        let regex = /^(\+?\d{1,3}[- ]?)?\d{11}$/;
        if (phone === '') {
            setPhoneError('Please enter phone no');
            return false;
        } else if (!regex.test(phone)) {
            setPhoneError('Please enter valid phone no');
            return false;
        } else {
            setPhoneError('');
            return true;
        }
    };
    const checkAltValidPhone = (val) => {
        state.alternateContactNo.set(val);
        handleDisableBtn();
        const phone = state.alternateContactNo.get() ?? '';
        let regex = /^(\+?\d{1,3}[- ]?)?\d{11}$/;
        if (regex.test(phone)) {
            setAltPhoneError('');
            return true;
        } else {
            if (
                state.eventForm.get() !== null &&
                state.eventForm
                    .get()
                    ?.FormFields[0].find(
                        (x) =>
                            x.FieldValue === true && x.FieldName !== 'NotAttend'
                    )
            ) {
                setAltPhoneError('Please enter valid phone no');
                return false;
            } else {
                if (phone != '') {
                    setAltPhoneError('Please enter valid phone no');
                    return false;
                } else {
                    setAltPhoneError('');
                    return true;
                }
            }
        }
    };

    const validateFirstName = () => {
        let value = state.firstName.get().trim();
        // if (value !== '') {
        //     if (Helper.isValidName(value)) {
        //         setFirstNameErr('');
        //         return true;
        //     } else setFirstNameErr('Please enter Valid Name');
        // } else {
        //     setFirstNameErr('Please enter Name');
        // }
        // return false;
        let isValid = true;
        if (value !== '') {
            value.split(' ').forEach(x => {
                if (!Helper.isValidName(x))
                    isValid = false
            })
        } else {
            isValid = false
        }
        if (value == '') {
            setFirstNameErr('Please Enter Name');
            return false;
            // return { flag: 'false', messages: 'Please Enter Name' };

        }
        else if (!isValid) {
            setFirstNameErr('Please Enter Valid Name');
            return false;
            // return { flag: 'false', messages: 'Please Enter Valid Name' };
        } else {
            setFirstNameErr('');
            return true;
        }
    };

    const validateAltName = () => {
        let value = state.alternateContactName.get().trim();
        let isValid = true;
        if (value !== '') {
            value.split(' ').forEach((x) => {
                if (!Helper.isValidName(x)) isValid = false;
            });
        } else {
            isValid = false;
        }
        if (isValid) {
            setAltNameErr('');
            return true;
        } else if (
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                ?.FormFields[0].find(
                    (x) => x.FieldValue === true && x.FieldName !== 'NotAttend'
                )
        ) {
            if (value == '') {
                setAltNameErr('Please enter  Name');
                return false;
            } else {
                setAltNameErr('Please enter valid Name');
                return false;
            }
        } else {
            if (value == '') {
                setAltNameErr('');
                return true;
            } else {
                setAltNameErr('Please enter valid Name');
                return false;
            }
        }
    };
    const validateHometown = () => {
        let value = state.hometown.get()?.trim();
        let isValid = true;
        if (value !== '') {
            value.split(' ').forEach((x) => {
                if (!Helper.onlyLettersAndSpacesWithHyphensAndDot(x)) isValid = false;
            });
        } else {
            isValid = false;
        }
        if (isValid) {
            setHomeTownErr('');
            return true;
        } else if (
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                ?.FormFields[0].find(
                    (x) => x.FieldValue === true && x.FieldName !== 'NotAttend'
                )
        ) {
            if (value == '') {
                setHomeTownErr('Please enter Hometown');
                return false;
            } else {
                setHomeTownErr('Please enter valid Hometown');
                return false;
            }
        } else {
            if (value == '') {
                setHomeTownErr('');
                return true;
            } else {
                setHomeTownErr('Please enter valid Hometown');
                return false;
            }
        }
    };
    const validateGreenRoomGuest1Name = () => {
        let value = state.greenRoomGuest1Name.get()?.trim();
        let isValid = true;
        if (value !== '') {
            value.split(' ').forEach((x) => {
                if (!Helper.onlyLettersAndSpacesWithHyphensAndDot(x)) isValid = false;
            });
        } else {
            isValid = false;
        }
        if (isValid) {
            setGreenRoomGuest1NameErr('');
            return true;
        } else if (
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                ?.FormFields[0].find(
                    (x) => x.FieldValue === true && x.FieldName !== 'NotAttend'
                )
        ) {
            if (value == '') {
                setGreenRoomGuest1NameErr('Please enter name');
                return false;
            } else {
                setGreenRoomGuest1NameErr('Please enter valid name');
                return false;
            }
        } else {
            if (value == '') {
                setGreenRoomGuest1NameErr('');
                return true;
            } else {
                setGreenRoomGuest1NameErr('Please enter valid name');
                return false;
            }
        }
    };
    const validateGreenRoomGuest2Name = () => {
        let value = state.greenRoomGuest2Name.get()?.trim();
        let isValid = true;
        if (value !== '') {
            value.split(' ').forEach((x) => {
                if (!Helper.onlyLettersAndSpacesWithHyphensAndDot(x)) isValid = false;
            });
        } else {
            isValid = false;
        }
        if (isValid) {
            setGreenRoomGuest2NameErr('');
            return true;
        } else if (
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                ?.FormFields[0].find(
                    (x) => x.FieldValue === true && x.FieldName !== 'NotAttend'
                )
        ) {
            if (value == '') {
                setGreenRoomGuest2NameErr('Please enter name');
                return false;
            } else {
                setGreenRoomGuest2NameErr('Please enter valid name');
                return false;
            }
        } else {
            if (value == '') {
                setGreenRoomGuest2NameErr('');
                return true;
            } else {
                setGreenRoomGuest2NameErr('Please enter valid name');
                return false;
            }
        }
    };
    const validateGreenRoomGuest1Relation = () => {
        let value = state.greenRoomGuest1Relation.get()?.trim();
        let isValid = true;
        if (value !== '') {
            value.split(' ').forEach((x) => {
                if (!Helper.onlyLettersAndSpacesWithHyphensAndDot(x)) isValid = false;
            });
        } else {
            isValid = false;
        }
        if (isValid) {
            setGreenRoomGuest1RelationErr('');
            return true;
        } else if (
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                ?.FormFields[0].find(
                    (x) => x.FieldValue === true && x.FieldName !== 'NotAttend'
                )
        ) {
            if (value == '') {
                setGreenRoomGuest1RelationErr('Please enter relation');
                return false;
            } else {
                setGreenRoomGuest1RelationErr('Please enter valid relation');
                return false;
            }
        } else {
            if (value == '') {
                setGreenRoomGuest1RelationErr('');
                return true;
            } else {
                setGreenRoomGuest1RelationErr('Please enter valid relation');
                return false;
            }
        }
    };
    const validateGreenRoomGuest2Relation = () => {
        let value = state.greenRoomGuest2Relation.get()?.trim();
        let isValid = true;
        if (value !== '') {
            value.split(' ').forEach((x) => {
                if (!Helper.onlyLettersAndSpacesWithHyphensAndDot(x)) isValid = false;
            });
        } else {
            isValid = false;
        }
        if (isValid) {
            setGreenRoomGuest2RelationErr('');
            return true;
        } else if (
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                ?.FormFields[0].find(
                    (x) => x.FieldValue === true && x.FieldName !== 'NotAttend'
                )
        ) {
            if (value == '') {
                setGreenRoomGuest2RelationErr('Please enter relation');
                return false;
            } else {
                setGreenRoomGuest2RelationErr('Please enter valid relation');
                return false;
            }
        } else {
            if (value == '') {
                setGreenRoomGuest2RelationErr('');
                return true;
            } else {
                setGreenRoomGuest2RelationErr('Please enter valid relation');
                return false;
            }
        }
    };
    const validateState = () => {
        let value = state.regState.get()?.trim();
        let isValid = true;
        if (value !== '') {
            value.split(' ').forEach((x) => {
                if (!Helper.onlyLettersAndSpacesWithHyphensAndDot(x)) isValid = false;
            });
        } else {
            isValid = false;
        }
        if (isValid) {
            setStateErr('');
            return true;
        } else if (
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                ?.FormFields[0].find(
                    (x) => x.FieldValue === true && x.FieldName !== 'NotAttend'
                )
        ) {
            if (value == '') {
                setStateErr('Please enter State');
                return false;
            } else {
                setStateErr('Please enter valid State');
                return false;
            }
        } else {
            if (value == '') {
                setStateErr('');
                return true;
            } else {
                setStateErr('Please enter valid State');
                return false;
            }
        }
    };
    const validateCountry = () => {
        let value = state.country.get()?.trim();
        let isValid = true;
        if (value !== '') {
            value.split(' ').forEach((x) => {
                if (!Helper.onlyLettersAndSpacesWithHyphensAndDot(x)) isValid = false;
            });
        } else {
            isValid = false;
        }
        if (isValid) {
            setCountryErr('');
            return true;
        } else if (
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                ?.FormFields[0].find(
                    (x) => x.FieldValue === true && x.FieldName !== 'NotAttend'
                )
        ) {
            if (value == '') {
                setCountryErr('Please enter Country');
                return false;
            } else {
                setCountryErr('Please enter valid Country');
                return false;
            }
        } else {
            if (value == '') {
                setCountryErr('');
                return true;
            } else {
                setCountryErr('Please enter valid Country');
                return false;
            }
        }
    };
    const validateUniversity = () => {
        let value = state.university.get()?.trim(); 

        if (
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                ?.FormFields[0].find(
                    (x) => x.FieldValue === true && x.FieldName !== 'NotAttend'
                )
        ) {
            if (value == '') {
                setUniversityErr('Please enter College or Club');
                return false;
            } else {
                setUniversityErr('');
                return true;
            }
        } else {
            if (value == '') {
                setUniversityErr('');
                return true;
            }
        }  
    };
    const validatelastName = () => {
        let value = state.lastName.get().trim();
        let isValid = true;
        if (value !== '') {
            value.split(' ').forEach(x => {
                if (!Helper.isValidName(x))
                    isValid = false
            })
        } else {
            isValid = false
        }

        if (value == '') {
            setLastNameErr('Please Enter Name');
            return false
            // return { flag: 'false', messages: 'Please Enter Name' };

        }
        else if (!isValid) {
            setLastNameErr('Please Enter Valid Name');
            return false
            // return { flag: 'false', messages: 'Please Enter Valid Name' };
        } else {
            setLastNameErr('');
            return true;
        }
    };

    function ValidateEmail() {
        const value = state.email.get();
        //state.email.set(value);
        if (Helper.validEmail(value)) {
            setEmailErr('');
            return true;
        } else if (value == '') {
            setEmailErr('Please enter Email');
            return false;
        } else {
            setEmailErr('Please enter valid Email');
            return false;
        }
    }
    function ValidateAlternateEmail() {
        const value = state.alternateContactEmail.get() ?? '';
        // state.alternateContactEmail.set(value);
        if (Helper.validEmail(value)) {
            setAltEmailErr('');
            return true;
        } else if (
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                .FormFields[0].find(
                    (x) => x.FieldValue === true && x.FieldName !== 'NotAttend'
                )
        ) {
            setAltEmailErr('Please enter valid Email');
            return false;
        } else {
            if (value != '') {
                setAltEmailErr('Please enter Email');
                return false;
            } else {
                setAltEmailErr('');
                return true;
            }
        }
    }

    const handleCancelReq = () => {
        resetState(true);
        dirty.set(false);
        props.handleCancel();
    };
    const getEventJSON = (participant) => {
        
            if (userInfo && !(Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)) ||
            (userInfo.roles && Helper.isEventStaff(userInfo)))) {
                let name = participant.name &&
                    participant.name !== null &&
                    participant.name !== ''
                    ? participant.name.split(', ')
                    : [];
                state.firstName.set(name[1] ?? participant.firstName);
                state.lastName.set(name[0] ?? participant.lastName);
                
                state.email.set(participant.email ?? '');
                state.contactNo.set(participant.contactNo ?? '');
            }
        if (participant?.userTags && participant?.userTags !== null) {
            let commonTags = eventTags.filter(
                (x) => participant.userTags.split(', ').indexOf(x.tagName) > -1
            );
            const splitTags = participant.userTags && participant.userTags.split(',');
            // console.log("splitTags",splitTags);

            if (splitTags && splitTags.length > 0) {
                for (var i = 0; i < splitTags.length; i++) {
                    if (splitTags[i].trim() === greenRoomTag.get()) {
                        showGreenRoomGuest.set(true)                        
                        break
                    }  else{
                        showGreenRoomGuest.set(false)  
                    }
                }  
            }
            // console.log(commonTags);
            return ApiHelper.post(
                APIURLConstants.GET_REGISTRATION_FORM(eventInfo.eventID),
                commonTags.map((x) => x.tagID)
            )
                .then((res) => {
                    if (res.data !== null && res.data !== '') { 
                        return JSON.parse(res.data.EventJSON);
                    } else {
                        return null;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    return null;
                });
        } 
    };
    const changeParticipant = async (participant) => {
        // eslint-disable-next-line no-debugger
        // console.log("participant",participant);

        setParticipant(participant);
        let formJSON = await getEventJSON(participant);
        if (participant) {
            let name =
                participant.name &&
                    participant.name !== null &&
                    participant.name !== ''
                    ? participant.name.split(', ')
                    : [];
            state.firstName.set(name[1] ?? participant.firstName);
            state.lastName.set(name[0] ?? participant.lastName);
            state.dob.set(
                Helper.IfDateIsDefault(participant.dob) ? null : participant.dob
            );
            state.email.set(participant.email ?? '');
            state.contactNo.set(participant.contactNo ?? '');
            //state.sex.set('');
            //state.vaccinated.set(0);
            state.alternateContactName.set('');
            state.alternateContactNo.set('');
            state.alternateContactEmail.set('');
            state.agentProDayParticipant.set(false);
            state.eventForm.set(formJSON ?? null);
            state.guestList.set(
                greenRoomSelf.get() !== 0
                    ? [
                        {
                            name: `${name[1] ?? participant.firstName} ${name[0] ?? participant.lastName
                                }`,
                            relationship: 'Self',
                            preDraftPicture: false,
                        },
                    ]
                    : []
            );
            state.lunchGuestList.set(
                greenRoomSelf.get() !== 0
                    ? [
                        {
                            name: `${name[1] ?? participant.firstName} ${name[0] ?? participant.lastName
                                }`,
                            relationship: 'Self',
                            preDraftPicture: false,
                        },
                    ]
                    : []
            );
            // state.checkBox1.set(false);
            // state.checkBox2.set(false);
            // state.checkBox3.set(false);
            // state.checkBox4.set(false);
            setFirstNameErr('');
            setLastNameErr('');
            setPhoneError('');
            setEmailErr('');
            setAltNameErr('');
            setAltEmailErr('');
            setAltPhoneError('');
        } else {
            resetState(false);
        }
        // state.registrationID.set(
        //     state.registrationID.get() > 0 ? state.registrationID.get() : 0
        // );
    };
    const handleRadioChange = (event, i) => {
        dirty.set(true);
        let eventForm = state.eventForm.attach(Downgraded).get();
        eventForm.FormFields[i].forEach((row) => {
            row['FieldValue'] = false;
        });
        let index = eventForm.FormFields[i].findIndex(
            (x) => x.FieldName === event.target.value
        );
        eventForm.FormFields[i][index]['FieldValue'] = event.target.checked;
        validateAltName();
        ValidateAlternateEmail();
        validateHometown()
        validateState()
        validateCountry()
        validateUniversity()
        validateGreenRoomGuest1Name()
        validateGreenRoomGuest2Name()
        validateGreenRoomGuest1Relation()
        validateGreenRoomGuest2Relation()
        if (
            eventForm !== null &&
            eventForm
                ?.FormFields[0].find(
                    (x) =>
                        x.FieldValue === true && x.FieldName !== 'NotAttend'
                ) && state.alternateContactNo.get() == ""
        ) {
            setAltPhoneError("Please enter alternate contact number")
        }
        else {
            setAltPhoneError("")
        }
        state.eventForm.set(eventForm);
        handleDisableBtn();
    };

    // const SETEmailNotification = (ObjRequest) => {
    //     ApiHelper.post(
    //         APIURLConstants.POST_SET_DRAFT_REGISTRATION_EMAIL_NOTIFICATION,
    //         ObjRequest
    //     )
    //         .then((result) => {
    //             console.log(result.data);
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         });
    // };

    const handleCheckBoxChange = (event) => {
        dirty.set(true);
        let eventForm = state.eventForm.attach(Downgraded).get();
        let index = eventForm.FormFields.findIndex(
            (x) => x.FieldName === event.target.name
        );
        eventForm.FormFields[index]['FieldValue'] = event.target.checked;
        state.eventForm.set(eventForm);
        handleDisableBtn();
    };

    const handleAddGuestClose = () => {
        openGuestDialog.set(false);
        stateGuestObj.set(null);
    };
    const handleAddLunchGuestClose = () => {
        openLunchGuestDialog.set(false);
        stateLunchGuestObj.set(null);
    };
    const handleGuestAction = (name, relationship, i) => {
        dirty.set(true);
        const values = [...state.attach(Downgraded).get().guestList];
        // console.log("values",values);
        if (!stateGuestObj.get() && values.length > Number(greenRoomGuest.get())) {
            setSnackBarProps({
                openSnack: true,
                variant: 'error',
                message: 'Already added ' + Number(greenRoomGuest.get()) + ' guests for Greenroom',
            });
        } else {
            if (i >= 0) {
                values[i].name = name;

                values[i].relationship = relationship;
                state.guestList.set(values);
            } else {
                values.push({
                    name: name,
                    relationship: relationship,
                });

                state.guestList.set(values);
            }
            stateGuestObj.set(null);
            openGuestDialog.set(false);
            handleDisableBtn();
        }
        setDisableBtn(false)
    };
    const handleLunchGuestAction = (name, relationship, i) => {
        dirty.set(true);
        const values = [...state.attach(Downgraded).get().lunchGuestList];
        if (!stateLunchGuestObj.get() && values.length > Number(lunchGuests.get())) {
            setSnackBarProps({
                openSnack: true,
                variant: 'error',
                message: 'Already added ' + Number(lunchGuests.get()) + ' guests for Lunch',
            });
        } else {
            if (i >= 0) {
                values[i].name = name;

                values[i].relationship = relationship;
                state.lunchGuestList.set(values);
            } else {
                values.push({
                    name: name,
                    relationship: relationship,
                });

                state.lunchGuestList.set(values);
            }
            stateLunchGuestObj.set(null);
            openLunchGuestDialog.set(false);
            handleDisableBtn();
        }
        setDisableBtn(false)
    };
    const handleAddGuestList = () => {
        openGuestDialog.set(true);
    };
    const handleAddLunchList = () => {
        openLunchGuestDialog.set(true);
    };
    const handleGuestEditData = (name, relationship, id) => {
        openGuestDialog.set(true);
        stateGuestObj.set({
            name: name,
            relationship: relationship,
            guestID: id,
        });
    };
    const handleLunchGuestEditData = (name, relationship, id) => {
        openLunchGuestDialog.set(true);
        stateLunchGuestObj.set({
            name: name,
            relationship: relationship,
            guestID: id,
        });
    };
    const handleRemoveGuest = (index) => {
        dirty.set(true);
        const values = state.attach(Downgraded).get().guestList;
        values.splice(index, 1);
        state.guestList.set(values);
        handleDisableBtn();
        setDisableBtn(false);
    };
    const handleRemoveLunchGuest = (index) => {
        dirty.set(true);
        const values = state.attach(Downgraded).get().lunchGuestList;
        values.splice(index, 1);
        state.lunchGuestList.set(values);
        handleDisableBtn();
        setDisableBtn(false);
    };
    const handlePreDraftPicChange = (event, index) => {
        dirty.set(true);
        const values = state.attach(Downgraded).get().guestList;
        values[index]['preDraftPicture'] = event.target.checked;
        state.guestList.set(values);
        setDisableBtn(true);
        handleDisableBtn();
    };
    const handleDisableBtn = () => {
        if (state.addedFor.get() > 0) {
            let registerData = props.data;
            // console.log(registerData);
            let prevData = {
                firstName: registerData.firstName,
                lastName: registerData.lastName,
                email: registerData.email,
                contactNo: registerData.contactNo,
                alternateContactName: registerData.alternateContactName,
                alternateContactNo: registerData.alternateContactNo,
                alternateContactEmail: registerData.alternateContactEmail,
                guestList: registerData.guestList,
                lunchGuestList: registerData.lunchGuestList,
                eventForm: registerData.eventForm,
                hometown:registerData.hometown,
                regState:registerData.state,
                country:registerData.country,
                university:registerData.university,
                pronunciationNotes:registerData.pronunciationNotes,
                greenRoomGuest1Name:registerData.guestList.length > 0 ? registerData.guestList[0].name : '',
                greenRoomGuest1Relation:registerData.guestList.length > 0 ? registerData.guestList[0].relationship :'',
                greenRoomGuest2Name:registerData.guestList.length > 0 ? registerData.guestList[1].name : '',
                greenRoomGuest2Relation:registerData.guestList.length > 0 ? registerData.guestList[1].relationship : '',
            };
            let currentData = {
                firstName: state.get().firstName,
                lastName: state.get().lastName,
                email: state.get().email,
                contactNo: state.get().contactNo,
                alternateContactName: state.get().alternateContactName,
                alternateContactNo: state.get().alternateContactNo,
                alternateContactEmail: state.get().alternateContactEmail,
                guestList: state.get().guestList,
                lunchGuestList: state.get().lunchGuestList,
                eventForm: JSON.stringify(state.get().eventForm),
                hometown:state.get().hometown,
                regState:state.get().regState,
                country:state.get().country,
                university:state.get().university,
                pronunciationNotes:state.get().pronunciationNotes,
                greenRoomGuest1Name:state.get().greenRoomGuest1Name,
                greenRoomGuest1Relation:state.get().greenRoomGuest1Relation,
                greenRoomGuest2Name:state.get().greenRoomGuest2Name,
                greenRoomGuest2Relation:state.get().greenRoomGuest2Relation,
            };
            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setDisableBtn(true);
            } else {
                setDisableBtn(false);
                state.isDisable.set(false)
            }
        }
        else {
            state.isDisable.set(false)
        }
    };
    // console.log("greenRoomSelf.get()",state.guestList.length, greenRoomGuest.get());
    return (
        <Box
        sx={{
            width:'100%'
        }}
        >
            <Box sx={{ ml: 2, mt: 2 }}>
                {' '}
                <Title title={Helper.getModuleName(eventInfo ? eventInfo.moduleDetails : [],
                    AppConstants.EVENT_MODULES.DRAFT_REGISTRATION)} header={true} />
                {moduleIndex.get() >= 0 &&
                    props.eventStateDetail.eventDetail !== null &&
                    props.eventStateDetail.eventDetail.moduleDetails[
                        moduleIndex.get()
                    ].details != null ? (
                    <DetailsComponent
                        data={
                            props.eventStateDetail.eventDetail.moduleDetails[
                                moduleIndex.get()
                            ].details
                        }
                    />
                ) : null}
            </Box>
            <Box
                className="contentBox">
                <Box component="div">
                    <Box sx={{ width: '100%' }}>
                        <Grid
                            container
                            rowSpacing={2}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }} sx={{mb:1}}>
                            {isParticipant && (
                                <Grid item container>
                                    <Grid item md={4}></Grid>
                                    <Grid item xs={12} md={4}>
                                        <ParticipantAutoList
                                            disableParticipant={
                                                props.data && props.data
                                                    ? true
                                                    : false
                                            }
                                            participant={participant}
                                            setParticipant={changeParticipant}
                                            participantList={
                                                props.participantList &&
                                                    props.participantList.length > 0
                                                    ? props.participantList
                                                    : participantList
                                            }
                                            modPermission={props.modPermission}
                                        />
                                    </Grid>
                                    <Grid item md={4}></Grid>
                                </Grid>)}
                        </Grid>
                        
                        {state.eventForm.attach(Downgraded).get() &&
                                            state.eventForm.attach(Downgraded).get() !== null &&
                                            state.eventForm.attach(Downgraded).get().Type && (<><AppBar
                            position="static"
                            color="default"
                            sx={appBarStyle}>
                            <Title
                                title={
                                    'Attendance:'
                                }
                                // addicon="land"
                                sx={{
                                    ml: 1,
                                    mt: 0.5,
                                }}
                            />
                        </AppBar>
                        <Grid container
                            rowSpacing={2}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                <Grid item container>
                                    <Grid item md={12}> 
                                                <>
                                                    <>
                                                        <Typography fontWeight={600}>
                                                            {
                                                                state.eventForm
                                                                    .attach(Downgraded)
                                                                    .get().Title
                                                            }
                                                            *
                                                        </Typography>
                                                        <Grid
                                                            sx={{
                                                                padding: 0,
                                                                flexDirection: 'column',
                                                            }}>
                                                            {state.eventForm.get().Type ===
                                                                'Option' ? (
                                                                state.eventForm
                                                                    .attach(Downgraded)
                                                                    .get()?.FormFields &&
                                                                state.eventForm
                                                                    .attach(Downgraded)
                                                                    .get()
                                                                    ?.FormFields?.map(
                                                                        (item, index) => {
                                                                            return (
                                                                                <Grid
                                                                                    item
                                                                                    lg={6}
                                                                                    md={6}
                                                                                    xs={12}
                                                                                    key={index}>
                                                                                    <FormControl>
                                                                                        <RadioGroup
                                                                                            aria-labelledby="demo-radio-buttons-group-label"
                                                                                            onChange={(
                                                                                                e
                                                                                            ) =>
                                                                                                handleRadioChange(
                                                                                                    e,
                                                                                                    index
                                                                                                )
                                                                                            }
                                                                                            value={
                                                                                                item &&
                                                                                                    item?.find(
                                                                                                        (
                                                                                                            x
                                                                                                        ) =>
                                                                                                            x.FieldValue ===
                                                                                                            true
                                                                                                    )
                                                                                                    ? item?.find(
                                                                                                        (
                                                                                                            x
                                                                                                        ) =>
                                                                                                            x.FieldValue ===
                                                                                                            true
                                                                                                    )
                                                                                                        ?.FieldName
                                                                                                    : ''
                                                                                            }
                                                                                            name="radio-buttons-group">
                                                                                            {item &&
                                                                                                item?.map(
                                                                                                    (
                                                                                                        elem,
                                                                                                        index
                                                                                                    ) => {
                                                                                                        return (
                                                                                                            <FormControlLabel
                                                                                                                disabled={
                                                                                                                    !checkEditPermission
                                                                                                                }
                                                                                                                key={
                                                                                                                    index
                                                                                                                }
                                                                                                                value={
                                                                                                                    elem.FieldName
                                                                                                                }
                                                                                                                control={
                                                                                                                    <Radio />
                                                                                                                }
                                                                                                                label={
                                                                                                                    elem.Description
                                                                                                                }
                                                                                                            />
                                                                                                        );
                                                                                                    }
                                                                                                )}
                                                                                        </RadioGroup>
                                                                                    </FormControl>
                                                                                    {state.eventForm
                                                                                        .attach(
                                                                                            Downgraded
                                                                                        )
                                                                                        .get()
                                                                                        ?.FormFields
                                                                                        ?.length -
                                                                                        1 !==
                                                                                        index && (
                                                                                            <Divider
                                                                                                light={
                                                                                                    false
                                                                                                }
                                                                                                sx={{
                                                                                                    mt: 1,
                                                                                                    marginRight: 0,
                                                                                                    mb: 1,
                                                                                                }}
                                                                                                flexItem
                                                                                            />
                                                                                        )}
                                                                                </Grid>
                                                                            );
                                                                        }
                                                                    )
                                                            ) : (
                                                                <FormGroup>
                                                                    {state.eventForm
                                                                        .attach(Downgraded)
                                                                        .get()?.FormFields &&
                                                                        state.eventForm
                                                                            .attach(Downgraded)
                                                                            .get()
                                                                            ?.FormFields?.map(
                                                                                (ele, index) => {
                                                                                    return (
                                                                                        <FormControlLabel
                                                                                            key={
                                                                                                index
                                                                                            }
                                                                                            control={
                                                                                                <Checkbox
                                                                                                    checked={
                                                                                                        ele.FieldValue
                                                                                                    }
                                                                                                    disabled={
                                                                                                        !checkEditPermission
                                                                                                    }
                                                                                                    name={
                                                                                                        ele.FieldName
                                                                                                    }
                                                                                                    onChange={
                                                                                                        handleCheckBoxChange
                                                                                                    }
                                                                                                />
                                                                                            }
                                                                                            label={
                                                                                                ele.Description
                                                                                            }
                                                                                        />
                                                                                    );
                                                                                }
                                                                            )}
                                                                </FormGroup>
                                                            )}
                                                        </Grid>
                                                    </>
                                                    <Divider
                                                        light={false}
                                                        sx={{ mt: 2, marginRight: 0, mb: 2 }}
                                                        flexItem
                                                    />
                                                </>
                                            
                                    </Grid>
                                </Grid>
                        </Grid>
                        </>)}
                        <AppBar
                            position="static"
                            color="default"
                            sx={appBarStyle}>
                            <Title
                                title={
                                    'Draft Announcement Information:'
                                } 
                                sx={{
                                    ml: 1,
                                    mt: 0.5,
                                }}
                            />
                        </AppBar>
                            {draftAnnouncementInfoText.get() && draftAnnouncementInfoText.get() != "" ? <Grid
                                container
                                rowSpacing={2}
                                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                                sx={{ mt: '4px' }}>
                                <Grid
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        ml:3
                                    }}>
                                    <Typography
                                        component="div"
                                        sx={{
                                            color: '',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            padding: '.5rem',
                                            fontSize: 12,
                                        }}>
                                        <>
                                            <Box
                                                component="span"
                                                sx={{ mb: 0.5 }}>
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: draftAnnouncementInfoText.get(),
                                                    }}></span>
                                            </Box>
                                        </>
                                    </Typography>
                                </Grid> 
                            </Grid>: null}
                            <Grid
                            container
                            rowSpacing={2}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                            sx={{mt:'4px'}}> 
                            <Grid item lg={6} md={6} xs={12}>
                                <TextField
                                    size="small"
                                    label="First Name"
                                    required
                                    disabled={!checkEditPermission}
                                    fullWidth
                                    minRows={2}
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={state.firstName.get()}
                                    onBlur={() =>
                                        params.userID > 0
                                            ? null
                                            : validateFirstName()
                                    }
                                    onChange={(event) => {
                                        state.firstName.set(event.target.value);
                                        dirty.set(true);
                                        handleDisableBtn();
                                    }}
                                    inputProps={{ maxLength: 50 }}
                                    error={
                                        firstNameErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        firstNameErr.length > 0
                                            ? firstNameErr
                                            : ''
                                    }
                                />{' '}
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                <TextField
                                    size="small"
                                    required
                                    disabled={!checkEditPermission}
                                    fullWidth
                                    onBlur={() =>
                                        params.userID > 0
                                            ? null
                                            : validatelastName()
                                    }
                                    label="Last Name"
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={state.lastName.get()}
                                    onChange={(event) => {
                                        state.lastName.set(event.target.value);
                                        dirty.set(true);
                                        handleDisableBtn();
                                    }}
                                    inputProps={{ maxLength: 50 }}
                                    error={
                                        lasttNameErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        lasttNameErr.length > 0
                                            ? lasttNameErr
                                            : ''
                                    }
                                />{' '}
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                {/* <TextField
                                required
                                fullWidth
                                label="Email"
                                id="outlined-basic"
                                variant="outlined"
                                value={state.email.get()}
                                onChange={(event) =>
                                {
                                    let str = event.target.value;
                                    str = str.replace(/^\s+/g, '');
                                    state.email.set(str);
                                }}
                                onBlur={() => params.userID > 0 ? null : isEmailExist()}
                                disabled={params.userID > 0 ? true : false}
                                inputProps={{ maxLength: 250 }}
                                error={
                                    emailErr.length > 0
                                        ? true
                                        : false
                                }
                                helperText={
                                    emailErr.length > 0
                                        ? emailErr
                                        : ''
                                }

                            /> */}

                                <TextField
                                    error={emailErr.length > 0 ? true : false}
                                    required
                                    fullWidth
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    label="Participant Email"
                                    onChange={(e) => {
                                        const email = e.target.value;
                                        state.email.set(email);
                                        dirty.set(true);
                                        handleDisableBtn();
                                    }}
                                    disabled={
                                        !checkEditPermission
                                            ? !checkEditPermission
                                            : params.userID > 0
                                                ? true
                                                : false
                                    }
                                    inputProps={{ maxLength: 250 }}
                                    helperText={emailErr}
                                    value={state.email.get()}
                                    onBlur={ValidateEmail}
                                />
                            </Grid> 
                            <Grid item lg={6} md={6} xs={12}>
                                <PhoneNumber
                                    name={'DraftRegistrationContact'}
                                    placeholder="Participant Contact No*"
                                    value={state.contactNo.get()}
                                    onChange={checkValidPhone}
                                    required={true}
                                    helperText={phoneError}
                                    error={phoneError.length > 0 ? true : false}
                                    disabled={
                                        !checkEditPermission
                                            ? !checkEditPermission
                                            : params.userID > 0
                                                ? true
                                                : false
                                    }
                                />
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                <TextField
                                    size="small"
                                    label="Hometown"
                                    required={
                                        state.eventForm.get() === null
                                            ? false
                                            : state.eventForm.get() !== null &&
                                                state.eventForm.get() !== null &&
                                                state.eventForm
                                                    .get()
                                                    .FormFields[0].find(
                                                        (x) =>
                                                            x.FieldValue ===
                                                            true &&
                                                            x.FieldName ===
                                                            'NotAttend'
                                                    )
                                                ? false
                                                : true
                                    }
                                    disabled={!checkEditPermission}
                                    fullWidth
                                    minRows={2}
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={state.hometown.get()}
                                    onBlur={() =>
                                        params.userID > 0
                                            ? null
                                            : validateHometown()
                                    }
                                    onChange={(event) => {
                                        state.hometown.set(event.target.value);
                                        dirty.set(true);
                                        handleDisableBtn();
                                    }}
                                    inputProps={{ maxLength: 50 }}
                                    error={
                                        hometownErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        hometownErr.length > 0
                                            ? hometownErr
                                            : ''
                                    }
                                />{' '}
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                <TextField
                                    size="small"
                                    label="State"
                                    required={
                                        state.eventForm.get() === null
                                            ? false
                                            : state.eventForm.get() !== null &&
                                                state.eventForm.get() !== null &&
                                                state.eventForm
                                                    .get()
                                                    .FormFields[0].find(
                                                        (x) =>
                                                            x.FieldValue ===
                                                            true &&
                                                            x.FieldName ===
                                                            'NotAttend'
                                                    )
                                                ? false
                                                : true
                                    }
                                    disabled={!checkEditPermission}
                                    fullWidth
                                    minRows={2}
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={state.regState.get()}
                                    onBlur={() =>
                                        params.userID > 0
                                            ? null
                                            : validateState()
                                    }
                                    onChange={(event) => {
                                        state.regState.set(event.target.value);
                                        dirty.set(true);
                                        handleDisableBtn();
                                    }}
                                    inputProps={{ maxLength: 50 }}
                                    error={
                                        stateErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        stateErr.length > 0
                                            ? stateErr
                                            : ''
                                    }
                                />{' '}
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                <TextField
                                    size="small"
                                    label="Country"
                                    required={
                                        state.eventForm.get() === null
                                            ? false
                                            : state.eventForm.get() !== null &&
                                                state.eventForm.get() !== null &&
                                                state.eventForm
                                                    .get()
                                                    .FormFields[0].find(
                                                        (x) =>
                                                            x.FieldValue ===
                                                            true &&
                                                            x.FieldName ===
                                                            'NotAttend'
                                                    )
                                                ? false
                                                : true
                                    }
                                    disabled={!checkEditPermission}
                                    fullWidth
                                    minRows={2}
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={state.country.get()}
                                    onBlur={() =>
                                        params.userID > 0
                                            ? null
                                            : validateCountry()
                                    }
                                    onChange={(event) => {
                                        state.country.set(event.target.value);
                                        dirty.set(true);
                                        handleDisableBtn();
                                    }}
                                    inputProps={{ maxLength: 50 }}
                                    error={
                                        countryErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        countryErr.length > 0
                                            ? countryErr
                                            : ''
                                    }
                                />{' '}
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                <TextField
                                    size="small"
                                    label="College or Club"
                                    required={
                                        state.eventForm.get() === null
                                            ? false
                                            : state.eventForm.get() !== null &&
                                                state.eventForm.get() !== null &&
                                                state.eventForm
                                                    .get()
                                                    .FormFields[0].find(
                                                        (x) =>
                                                            x.FieldValue ===
                                                            true &&
                                                            x.FieldName ===
                                                            'NotAttend'
                                                    )
                                                ? false
                                                : true
                                    }
                                    disabled={!checkEditPermission}
                                    fullWidth
                                    minRows={2}
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={state.university.get()}
                                    onBlur={() =>
                                        params.userID > 0
                                            ? null
                                            : validateUniversity()
                                    }
                                    onChange={(event) => {
                                        state.university.set(event.target.value);
                                        dirty.set(true);
                                        handleDisableBtn();
                                    }}
                                    inputProps={{ maxLength: 50 }}
                                    error={
                                        universityErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        universityErr.length > 0
                                            ? universityErr
                                            : ''
                                    }
                                />{' '}
                            </Grid>
                            <Grid item lg={12} md={12} xs={12}>
                                <TextField
                                    size="small"
                                    label="Pronunciation Notes" 
                                    disabled={!checkEditPermission}
                                    fullWidth
                                    minRows={2}
                                    multiline
                                    maxRows={3}
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={state.pronunciationNotes.get()} 
                                    onChange={(event) => {
                                        state.pronunciationNotes.set(event.target.value);
                                        dirty.set(true);
                                        handleDisableBtn();
                                    }}
                                    inputProps={{ maxLength: 50 }} 
                                />{' '}
                            </Grid>
                        </Grid>
                    </Box>

                    <Divider
                        light={false}
                        sx={{ mt: 2, marginRight: 0, mb: 2 }}
                        flexItem
                    />
                    

                    <Box component="div" sx={{ width: '100%' }}>
                       
                            <AppBar
                                position="static"
                                color="default"
                                sx={appBarStyle}>
                                <Title
                                    title={
                                        'Alternate contact person information:'
                                    }
                                    // addicon="land"
                                    sx={{
                                        ml: 1,
                                        mt: 0.5,
                                    }}
                                />
                            </AppBar>
                            <Grid
                            container
                            rowSpacing={2}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                            sx={{mt:'4px'}}>

                            {/* <Grid item lg={4} md={4} xs={12}>
                            <FormControl fullWidth >
                                <LocalizationProvider
                                    dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        label="Date of Birth"
                                        disabled={!checkEditPermission}
                                        maxDate={new Date()}
                                        value={state.dob
                                            .attach(Downgraded)
                                            .get()}
                                        inputProps={{ readOnly: true }}
                                        // onChange={() => console.log("hi")}
                                        onChange={(newDob) => {
                                            state.dob.set(
                                                Helper.FormatDate(newDob)
                                            );
                                            handleBlur(
                                                Helper.FormatDate(newDob)
                                            );
                                        }}

                                        //onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField
                                                size="small"
                                                {...params}
                                                required={state.eventForm.get() !== null && state.eventForm.get().FormFields.find(x => x.FieldValue === true && x.FieldName === 'NotAttend') ? false : true}
                                                helperText={dobErr}
                                                error={
                                                    dobErr.length > 0
                                                        ? true
                                                        : false
                                                }
                                            />
                                        )}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid> */}
                            {/* {showAgentProParticipant &&
                            <Grid item lg={4} md={4} xs={12}>
                                <FormGroup sx={{ alignContent: 'flex-start' }}>
                                    <FormControlLabel sx={{ p: 0, m: 0 }}
                                        labelPlacement='start'
                                        control={<Switch disabled={!checkEditPermission} checked={state.agentProDayParticipant.get()} onChange={(e) => state.agentProDayParticipant.set(e.target.checked)} />}
                                        label="Are you planning to participate in an agent Pro Day at the NBA Draft Combine in Chicago?" />
                                </FormGroup>
                            </Grid>
                        } */}
                            {/* <Grid item lg={12} md={12} xs={12}>
                            <Typography fontWeight={600}>
                                Alternate Contact (please list family member, agent or coach)
                            </Typography>
                        </Grid> */}
                            <Grid item lg={4} md={4} xs={12}>
                                <TextField
                                    fullWidth
                                    required={
                                        state.eventForm.get() === null
                                            ? false
                                            : state.eventForm.get() !== null &&
                                                state.eventForm.get() !== null &&
                                                state.eventForm
                                                    .get()
                                                    .FormFields[0].find(
                                                        (x) =>
                                                            x.FieldValue ===
                                                            true &&
                                                            x.FieldName ===
                                                            'NotAttend'
                                                    )
                                                ? false
                                                : true
                                    }
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    label="Alternate Contact Name  "
                                    inputProps={{ maxLength: 200 }}
                                    disabled={!checkEditPermission}
                                    value={state.alternateContactName.get()}
                                    onBlur={() =>
                                        params.userID > 0
                                            ? null
                                            : validateAltName()
                                    }
                                    error={altNameErr.length > 0 ? true : false}
                                    helperText={
                                        altNameErr.length > 0 ? altNameErr : ''
                                    }
                                    onChange={(e) => {
                                        regex.test(e.target.value)
                                            ? state.alternateContactName.set(
                                                e.target.value
                                            )
                                            : state.alternateContactName.set(
                                                e.target.value.trim()
                                            );
                                        dirty.set(true);
                                        handleDisableBtn();
                                    }}
                                />
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                <TextField
                                    error={
                                        altEmailErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        altEmailErr.length > 0
                                            ? altEmailErr
                                            : ''
                                    }
                                    fullWidth
                                    required={
                                        state.eventForm.get() === null
                                            ? false
                                            : state.eventForm.get() !== null &&
                                                state.eventForm.get() !== null &&
                                                state.eventForm
                                                    .get()
                                                    .FormFields[0].find(
                                                        (x) =>
                                                            x.FieldValue ===
                                                            true &&
                                                            x.FieldName ===
                                                            'NotAttend'
                                                    )
                                                ? false
                                                : true
                                    }
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    onChange={(e) => {
                                        const email = e.target.value;
                                        state.alternateContactEmail.set(email);
                                        dirty.set(true);
                                        handleDisableBtn();
                                    }}
                                    disabled={!checkEditPermission}
                                    label="Alternate Contact Email"
                                    inputProps={{ maxLength: 255 }}
                                    value={state.alternateContactEmail.get()}
                                    onBlur={ValidateAlternateEmail}
                                />
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                <PhoneNumber
                                    name={'DraftRegistrationContact'}
                                    placeholder={
                                        state.eventForm.get() === null
                                            ? 'Alternate Contact No'
                                            : state.eventForm.get() &&
                                                state.eventForm.get() !== null &&
                                                state.eventForm
                                                    .get()
                                                    .FormFields[0].find(
                                                        (x) =>
                                                            x.FieldValue ===
                                                            true &&
                                                            x.FieldName ===
                                                            'NotAttend'
                                                    )
                                                ? 'Alternate Contact No'
                                                : 'Alternate Contact No*'
                                    }
                                    value={state.alternateContactNo.get()}
                                    onChange={checkAltValidPhone}
                                    required={state.eventForm.get() === null
                                        ? false
                                        : state.eventForm.get() &&
                                            state.eventForm.get() !== null &&
                                            state.eventForm
                                                .get()
                                                .FormFields[0].find(
                                                    (x) =>
                                                        x.FieldValue ===
                                                        true &&
                                                        x.FieldName ===
                                                        'NotAttend'
                                                )
                                            ? false
                                            : true}
                                    helperText={altPhoneError}
                                    error={
                                        altPhoneError.length > 0 ? true : false
                                    }
                                    disabled={
                                        !checkEditPermission
                                            ? !checkEditPermission
                                            : params.userID > 0
                                                ? true
                                                : false
                                    }
                                />
                            </Grid>
                            
                        </Grid>
                    </Box>
                    {/* <Divider
                    light={false}
                    sx={{ mt: 2, marginRight: 0, mb: 2 }}
                    flexItem
                /> */}
                    {/* <Grid sx={{ padding: 0 }}>
                    <AppBar position='static' color='default' sx={appBarStyle}>
                        <Title title='Guest List' sx={{ ml: 1 }}></Title>
                    </AppBar>
                </Grid> */}

                    {showGreenRoomGuest.get() && (
                        <Box component="div" sx={{ width: '100%' }}>
                            <Grid sx={{ padding: '16px 0', mt: 2 }}>
                                
                                    <AppBar
                                        position="static"
                                        color="default"
                                        sx={appBarStyle}>
                                        <div
                                            style={{
                                                justifyContent: 'space-between',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'baseline',
                                            }}>
                                            <Title
                                                title={greenRoomTitleText.get()}
                                                // addicon="land"
                                                sx={{
                                                    ml: 1,
                                                }}
                                            />
                                            {/* <Button
                                                variant="contained"
                                                size="small"
                                                disabled={ 
                                                        eventInfo.readonlyOrHide === 1
                                                        ? eventRole !==
                                                            AppConstants
                                                                .EVENT_ROLES[0]
                                                            ? userInfo.userType !==
                                                                AppConstants
                                                                    .USER_TYPES[0]
                                                                ? true
                                                                : false
                                                            : false
                                                        : props.modPermission ===
                                                            VIEW_PERMISSION
                                                            ? true
                                                            : state.guestList.length >
                                                            (greenRoomGuest.get() + greenRoomSelf.get() !== 0 ?  1 : 0) ? true : false
                                                }
                                                onClick={handleAddGuestList}
                                                color="primary">
                                                + Add Guest
                                            </Button> */}
                                        </div>
                                    </AppBar>
                                 {/* <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                // alignItems: 'center',
                                justifyContent: 'space-between',
                                backgroundColor: '#f8f8f8',
                                flex: 1,
                                marginBottom: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={{
                                        xs: '12px',
                                        md: '16px',
                                    }}
                                    fontWeight={500}
                                    paddingLeft={1}
                                    paddingTop={1}
                                    color={'primary'}
                                    pb={1}>
                                    Green Room Table
                                </Typography>
                            </Box>
                            <Box sx={{ padding: 1 }}>
                                <Button
                                    variant="contained"
                                    disabled={state.guestList.length === greenRoomGuest.get() + 1}
                                    onClick={handleAddGuestList}
                                    color="primary">
                                    + Add Guest
                                </Button>
                            </Box>
                        </Box> */}
                                <Grid sx={{ padding: 0 }}>
                                    <Grid
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                        }}>
                                        <Typography
                                            component="div"
                                            sx={{
                                                color: '',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                padding: '.5rem',
                                                fontSize: 12,
                                            }}>
                                            <>
                                                <Box
                                                    component="span"
                                                    sx={{ mb: 0.5 }}>
                                                    <span
                                                        dangerouslySetInnerHTML={{
                                                            __html: greenRoomGuestsText.get(),
                                                        }}></span>
                                                </Box>

                                                {isPreDraftPicture.get() === true ? <Box
                                                    component="span"
                                                    sx={{ mb: 0.5 }}>
                                                    {`All  ${Helper.capitalize(Helper.numToWords(greenRoomGuest.get()))} (${greenRoomGuest.get()}) green room guests must have a credential. As such, please e-mail a picture (JPG or PNG format, under 2 MB) for each Green Room guest on a plain white background to Ivy Lin (`}
                                                    <a href="#" target="_blank">
                                                        ilin@nba.com
                                                    </a>
                                                    {`) ASAP.`}
                                                </Box> : null}
                                            </>
                                        </Typography>
                                    </Grid>
                                </Grid>

                                {/* {state.guestList.attach(Downgraded).get().length >
                                    0 && ( */}
                                    <Box 
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            flex: 1,
                                            marginTop: 1, 
                                        }}
                                    >
                                        <Box
                                            flex={0.13}
                                            sx={{
                                                justifyContent:
                                                    'center',
                                            }}>
                                            <Typography
                                                variant="h2"
                                                fontSize={14}
                                                fontWeight={400}
                                                paddingLeft={1}
                                                paddingTop={1}
                                                sx={{
                                                    paddingLeft: 5,
                                                }}
                                                pb={1}>
                                                Guest 1
                                            </Typography>
                                        </Box>

                                        <Box
                                            flex={0.33}
                                            sx={{
                                                display: 'flex',
                                                flexDirection:
                                                    'row',
                                                alignItems:
                                                    'center',
                                            }}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems:
                                                        'center',
                                                    flex: 0.9,
                                                }}>
                                                <TextField
                                                    size="small"
                                                    label="Name"
                                                    required={
                                                        state.eventForm.get() === null
                                                            ? false
                                                            : state.eventForm.get() !== null &&
                                                                state.eventForm.get() !== null &&
                                                                state.eventForm
                                                                    .get()
                                                                    .FormFields[0].find(
                                                                        (x) =>
                                                                            x.FieldValue ===
                                                                            true &&
                                                                            x.FieldName ===
                                                                            'NotAttend'
                                                                    )
                                                                ? false
                                                                : true
                                                    }
                                                    disabled={!checkEditPermission}
                                                    fullWidth
                                                    minRows={2}
                                                    id="outlined-basic"
                                                    variant="outlined"
                                                    value={state.greenRoomGuest1Name.get()}
                                                    onBlur={() =>
                                                        params.userID > 0
                                                            ? null
                                                            : validateGreenRoomGuest1Name()
                                                    }
                                                    onChange={(event) => {
                                                        state.greenRoomGuest1Name.set(event.target.value);
                                                        dirty.set(true);
                                                        handleDisableBtn();
                                                    }}
                                                    inputProps={{ maxLength: 50 }}
                                                    error={
                                                        greenRoomGuest1NameErr.length > 0 ? true : false
                                                    }
                                                    helperText={
                                                        greenRoomGuest1NameErr.length > 0
                                                            ? greenRoomGuest1NameErr
                                                            : ''
                                                    }
                                                />
                                            </Box>
                                        </Box>
                                        <Box
                                            flex={0.33}
                                            sx={{
                                                display: 'flex',
                                                flexDirection:
                                                    'row',
                                                alignItems:
                                                    'center',
                                            }}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems:
                                                        'center',
                                                    flex: 0.9,
                                                }}>
                                                <TextField
                                                    size="small"
                                                    label="Relation"
                                                    required={
                                                        state.eventForm.get() === null
                                                            ? false
                                                            : state.eventForm.get() !== null &&
                                                                state.eventForm.get() !== null &&
                                                                state.eventForm
                                                                    .get()
                                                                    .FormFields[0].find(
                                                                        (x) =>
                                                                            x.FieldValue ===
                                                                            true &&
                                                                            x.FieldName ===
                                                                            'NotAttend'
                                                                    )
                                                                ? false
                                                                : true
                                                    }
                                                    disabled={!checkEditPermission}
                                                    fullWidth
                                                    minRows={2}
                                                    id="outlined-basic"
                                                    variant="outlined"
                                                    value={state.greenRoomGuest1Relation.get()}
                                                    onBlur={() =>
                                                        params.userID > 0
                                                            ? null
                                                            : validateGreenRoomGuest1Relation()
                                                    }
                                                    onChange={(event) => {
                                                        state.greenRoomGuest1Relation.set(event.target.value);
                                                        dirty.set(true);
                                                        handleDisableBtn();
                                                    }}
                                                    inputProps={{ maxLength: 50 }}
                                                    error={
                                                        greenRoomGuest1RelationErr.length > 0 ? true : false
                                                    }
                                                    helperText={
                                                        greenRoomGuest1RelationErr.length > 0
                                                            ? greenRoomGuest1RelationErr
                                                            : ''
                                                    }
                                                />
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box 
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            flex: 1,
                                            marginTop: 1, 
                                        }}
                                    >
                                        <Box
                                            flex={0.13}
                                            sx={{
                                                justifyContent:
                                                    'center',
                                            }}>
                                            <Typography
                                                variant="h2"
                                                fontSize={14}
                                                fontWeight={400}
                                                paddingLeft={1}
                                                paddingTop={1}
                                                sx={{
                                                    paddingLeft: 5,
                                                }}
                                                pb={1}>
                                                Guest 2
                                            </Typography>
                                        </Box>

                                        <Box
                                            flex={0.33}
                                            sx={{
                                                display: 'flex',
                                                flexDirection:
                                                    'row',
                                                alignItems:
                                                    'center',
                                            }}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems:
                                                        'center',
                                                    flex: 0.9,
                                                }}>
                                                <TextField
                                                    size="small"
                                                    label="Name"
                                                    required={
                                                        state.eventForm.get() === null
                                                            ? false
                                                            : state.eventForm.get() !== null &&
                                                                state.eventForm.get() !== null &&
                                                                state.eventForm
                                                                    .get()
                                                                    .FormFields[0].find(
                                                                        (x) =>
                                                                            x.FieldValue ===
                                                                            true &&
                                                                            x.FieldName ===
                                                                            'NotAttend'
                                                                    )
                                                                ? false
                                                                : true
                                                    }
                                                    disabled={!checkEditPermission}
                                                    fullWidth
                                                    minRows={2}
                                                    id="outlined-basic"
                                                    variant="outlined"
                                                    value={state.greenRoomGuest2Name.get()}
                                                    onBlur={() =>
                                                        params.userID > 0
                                                            ? null
                                                            : validateGreenRoomGuest2Name()
                                                    }
                                                    onChange={(event) => {
                                                        state.greenRoomGuest2Name.set(event.target.value);
                                                        dirty.set(true);
                                                        handleDisableBtn();
                                                    }}
                                                    inputProps={{ maxLength: 50 }}
                                                    error={
                                                        greenRoomGuest2NameErr.length > 0 ? true : false
                                                    }
                                                    helperText={
                                                        greenRoomGuest2NameErr.length > 0
                                                            ? greenRoomGuest2NameErr
                                                            : ''
                                                    }
                                                />
                                            </Box>
                                        </Box>
                                        <Box
                                            flex={0.33}
                                            sx={{
                                                display: 'flex',
                                                flexDirection:
                                                    'row',
                                                alignItems:
                                                    'center',
                                            }}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems:
                                                        'center',
                                                    flex: 0.9,
                                                }}>
                                                <TextField
                                                    size="small"
                                                    label="Relation"
                                                    required={
                                                        state.eventForm.get() === null
                                                            ? false
                                                            : state.eventForm.get() !== null &&
                                                                state.eventForm.get() !== null &&
                                                                state.eventForm
                                                                    .get()
                                                                    .FormFields[0].find(
                                                                        (x) =>
                                                                            x.FieldValue ===
                                                                            true &&
                                                                            x.FieldName ===
                                                                            'NotAttend'
                                                                    )
                                                                ? false
                                                                : true
                                                    }
                                                    disabled={!checkEditPermission}
                                                    fullWidth
                                                    minRows={2}
                                                    id="outlined-basic"
                                                    variant="outlined"
                                                    value={state.greenRoomGuest2Relation.get()}
                                                    onBlur={() =>
                                                        params.userID > 0
                                                            ? null
                                                            : validateGreenRoomGuest2Relation()
                                                    }
                                                    onChange={(event) => {
                                                        state.greenRoomGuest2Relation.set(event.target.value);
                                                        dirty.set(true);
                                                        handleDisableBtn();
                                                    }}
                                                    inputProps={{ maxLength: 50 }}
                                                    error={
                                                        greenRoomGuest2RelationErr.length > 0 ? true : false
                                                    }
                                                    helperText={
                                                        greenRoomGuest2RelationErr.length > 0
                                                            ? greenRoomGuest2RelationErr
                                                            : ''
                                                    }
                                                />
                                            </Box>
                                        </Box>
                                    </Box>

                                {/* <Grid px={0}>
                                    {state.guestList.attach(Downgraded).get()
                                        .length > 0 &&
                                        state.guestList
                                            .attach(Downgraded)
                                            .get()
                                            .map((field, idx) => {
                                                return (
                                                    <Box
                                                        key={idx}
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            flex: 1,
                                                            marginTop: 1,
                                                            backgroundColor:
                                                                '#f8f8f8',
                                                        }}>
                                                        <Box
                                                            flex={0.3}
                                                            sx={{
                                                                justifyContent:
                                                                    'center',
                                                            }}>
                                                            <Typography
                                                                variant="h2"
                                                                fontSize={14}
                                                                fontWeight={400}
                                                                paddingLeft={1}
                                                                paddingTop={1}
                                                                sx={{
                                                                    paddingLeft: 5,
                                                                }}
                                                                pb={1}>
                                                                {field.name}
                                                            </Typography>
                                                        </Box>

                                                        <Box
                                                            flex={0.7}
                                                            sx={{
                                                                display: 'flex',
                                                                flexDirection:
                                                                    'row',
                                                                alignItems:
                                                                    'center',
                                                            }}>
                                                            <Box
                                                                sx={{
                                                                    display: 'flex',
                                                                    alignItems:
                                                                        'center',
                                                                    flex: 0.5,
                                                                }}>
                                                                <Typography
                                                                    variant="h2"
                                                                    fontSize={14}
                                                                    fontWeight={400}
                                                                    paddingLeft={1}
                                                                    paddingTop={1}
                                                                    sx={{
                                                                        paddingLeft: 5,
                                                                    }}
                                                                    pb={1}>
                                                                    {
                                                                        field.relationship
                                                                    }
                                                                </Typography>
                                                            </Box>
                                                            <Box
                                                                sx={{
                                                                    display: 'flex',
                                                                    alignItems:
                                                                        'center',
                                                                    flex: 0.5,
                                                                }}>
                                                                {(isPreDraftPicture.get() === true && greenRoomSelf.get() === 0) ? (
                                                                    <Checkbox
                                                                        sx={{
                                                                            ml: 5,
                                                                        }}
                                                                        disabled={
                                                                            field.preDraftPicture
                                                                                ? false
                                                                                : state.guestList
                                                                                    .attach(
                                                                                        Downgraded
                                                                                    )
                                                                                    .get()
                                                                                    .filter(
                                                                                        (
                                                                                            x
                                                                                        ) =>
                                                                                            x.preDraftPicture ===
                                                                                            true
                                                                                    )
                                                                                    .length ===
                                                                                    preDraftPic.get() ||
                                                                                    props.modPermission ===
                                                                                    VIEW_PERMISSION
                                                                                    ? true
                                                                                    : false
                                                                        }
                                                                        checked={
                                                                            field.preDraftPicture
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            handlePreDraftPicChange(
                                                                                e,
                                                                                idx
                                                                            )
                                                                        }
                                                                    />
                                                                ) : isPreDraftPicture.get() === true ? idx !== 0 && (
                                                                    <Checkbox
                                                                        sx={{
                                                                            ml: 5,
                                                                        }}
                                                                        disabled={
                                                                            field.preDraftPicture
                                                                                ? false
                                                                                : state.guestList
                                                                                    .attach(
                                                                                        Downgraded
                                                                                    )
                                                                                    .get()
                                                                                    .filter(
                                                                                        (
                                                                                            x
                                                                                        ) =>
                                                                                            x.preDraftPicture ===
                                                                                            true
                                                                                    )
                                                                                    .length ===
                                                                                    preDraftPic.get() ||
                                                                                    props.modPermission ===
                                                                                    VIEW_PERMISSION
                                                                                    ? true
                                                                                    : false
                                                                        }
                                                                        checked={
                                                                            field.preDraftPicture
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            handlePreDraftPicChange(
                                                                                e,
                                                                                idx
                                                                            )
                                                                        }
                                                                    />
                                                                ) : null}
                                                            </Box>
                                                            <Box
                                                                sx={{
                                                                    display: 'flex',
                                                                    alignItems:
                                                                        'center',
                                                                    flex: 0.05,
                                                                }}>
                                                                {(greenRoomSelf.get() === 0 ? 0 == 0 : idx !== 0) && props.modPermission !==
                                                                    VIEW_PERMISSION ? (
                                                                    <Box
                                                                        component="img"
                                                                        className={
                                                                            classes.sedanBlack
                                                                        }
                                                                        disabled={
                                                                            true
                                                                        }
                                                                        alt="logo."
                                                                        src={
                                                                            IconPencil
                                                                        }
                                                                        onClick={() =>
                                                                            handleGuestEditData(
                                                                                field.name,
                                                                                field.relationship,
                                                                                idx
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <Box></Box>
                                                                )}
                                                            </Box>
                                                            <Box
                                                                sx={{
                                                                    display: 'flex',
                                                                    alignItems:
                                                                        'center',
                                                                    flex: 0.05,
                                                                }}>
                                                                {(greenRoomSelf.get() === 0 ? 0 == 0 : idx !== 0) && props.modPermission !==
                                                                    VIEW_PERMISSION ? (
                                                                    <Box
                                                                        component="img"
                                                                        className={
                                                                            classes.sedanBlack
                                                                        }
                                                                        alt="logo."
                                                                        src={trash}
                                                                        onClick={() =>
                                                                            handleRemoveGuest(
                                                                                idx
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <Box></Box>
                                                                )}
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                );
                                            })}
                                </Grid> */}
                            </Grid>
                        </Box>
                    )}
                    {lunchGuests.get() !== 0 && (
                        <Grid sx={{ padding: '16px 0' }}>
                            <Grid
                                container
                                rowSpacing={2}
                                columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                <AppBar
                                    position="static"
                                    color="default"
                                    sx={appBarStyle}>
                                    <div
                                        style={{
                                            justifyContent: 'space-between',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'baseline',
                                        }}>
                                        <Title
                                            title={
                                                'NBA Draftee/Guest Commissioner’s  Luncheon'
                                            }
                                            // addicon="land"
                                            sx={{
                                                ml: 1,
                                            }}
                                        />
                                        <Button
                                            variant="contained"
                                            size="small"
                                            disabled={
                                                state.firstName.get().trim() ===
                                                    '' ||
                                                    state.lunchGuestList.length ===
                                                    lunchGuests.get() + 1 ||
                                                    eventInfo.readonlyOrHide === 1
                                                    ? eventRole !==
                                                        AppConstants
                                                            .EVENT_ROLES[0]
                                                        ? userInfo.userType !==
                                                            AppConstants
                                                                .USER_TYPES[0]
                                                            ? true
                                                            : false
                                                        : false
                                                    : props.modPermission ===
                                                        VIEW_PERMISSION
                                                        ? true
                                                        : false
                                            }
                                            onClick={handleAddLunchList}
                                            color="primary">
                                            + Add Guest
                                        </Button>
                                    </div>
                                </AppBar>
                            </Grid>
                            {/* <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            // alignItems: 'center',
                            justifyContent: 'space-between',
                            backgroundColor: '#f8f8f8',
                            flex: 1,
                            marginBottom: 1,
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                            }}>
                            <Typography
                                variant="h4"
                                fontSize={{
                                    xs: '12px',
                                    md: '16px',
                                }}
                                fontWeight={500}
                                paddingLeft={1}
                                paddingTop={1}
                                color={'primary'}
                                pb={1}>
                                Draftee/Guest Lunch
                            </Typography>
                        </Box>
                        <Box sx={{ padding: 1 }}>
                            <Button
                                variant="contained"
                                disabled={state.lunchGuestList.length === lunchGuests.get() + 1}
                                onClick={handleAddLunchList}
                                color="primary">
                                + Add Guest
                            </Button>
                        </Box>
                    </Box> */}
                            <Grid sx={{ padding: 0 }}>
                                <Grid
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                    }}>
                                    <Typography
                                        sx={{
                                            color: '',
                                            padding: '.5rem',
                                            fontSize: 12,
                                        }}>
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: lunchRoomGuestsText.get(),
                                            }}></span>
                                        {/* Please note all ${lunchGuests.get()} guests must be fully vaccinated. Vaccination status can be entered via this`}{' '} */}
                                        {/* <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href="https://tmbo.iad1.qualtrics.com/jfe/form/SV_5sZ07j7QSyFDcX4">
                                        link
                                    </a> */}
                                    </Typography>
                                </Grid>
                            </Grid>
                            {state.lunchGuestList.attach(Downgraded).get()
                                .length > 0 && (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            backgroundColor: '#F1F6FF',
                                            flex: 1,
                                            marginTop: 2,
                                        }}>
                                        <Box
                                            flex={0.3}
                                            sx={{ justifyContent: 'center' }}>
                                            <Typography
                                                variant="h2"
                                                fontSize={12}
                                                fontWeight={500}
                                                paddingLeft={1}
                                                paddingTop={1}
                                                sx={{ paddingLeft: 5 }}
                                                color={'primary'}
                                                pb={1}>
                                                Name
                                            </Typography>
                                        </Box>

                                        <Box
                                            flex={0.7}
                                            maxLength={10}
                                            style={{ wordBreak: 'break-all' }}>
                                            <Typography
                                                variant="h2"
                                                fontSize={12}
                                                fontWeight={500}
                                                paddingLeft={1}
                                                paddingTop={1}
                                                sx={{ paddingLeft: 5 }}
                                                color={'primary'}
                                                pb={1}>
                                                Relation
                                            </Typography>
                                        </Box>
                                    </Box>
                                )}

                            <Grid px={0}>
                                {state.lunchGuestList.attach(Downgraded).get()
                                    .length > 0 &&
                                    state.lunchGuestList
                                        .attach(Downgraded)
                                        .get()
                                        .map((field, idx) => {
                                            return (
                                                <Box
                                                    key={idx}
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        flex: 1,
                                                        marginTop: 1,
                                                        backgroundColor:
                                                            '#f8f8f8',
                                                    }}>
                                                    <Box
                                                        flex={0.3}
                                                        sx={{
                                                            justifyContent:
                                                                'center',
                                                        }}>
                                                        <Typography
                                                            variant="h2"
                                                            fontSize={14}
                                                            fontWeight={400}
                                                            paddingLeft={1}
                                                            paddingTop={1}
                                                            sx={{
                                                                paddingLeft: 5,
                                                            }}
                                                            pb={1}>
                                                            {field.name}
                                                        </Typography>
                                                    </Box>

                                                    <Box
                                                        flex={0.7}
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'row',
                                                            alignItems:
                                                                'center',
                                                        }}>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems:
                                                                    'center',
                                                                flex: 0.9,
                                                            }}>
                                                            <Typography
                                                                variant="h2"
                                                                fontSize={14}
                                                                fontWeight={400}
                                                                paddingLeft={1}
                                                                paddingTop={1}
                                                                sx={{
                                                                    paddingLeft: 5,
                                                                }}
                                                                pb={1}>
                                                                {
                                                                    field.relationship
                                                                }
                                                            </Typography>
                                                        </Box>
                                                        {idx !== 0 &&
                                                            props.modPermission !==
                                                            VIEW_PERMISSION && (
                                                                <Box
                                                                    sx={{
                                                                        display:
                                                                            'flex',
                                                                        alignItems:
                                                                            'center',
                                                                        flex: 0.05,
                                                                    }}>
                                                                    <Box
                                                                        component="img"
                                                                        className={
                                                                            classes.sedanBlack
                                                                        }
                                                                        alt="logo."
                                                                        src={
                                                                            IconPencil
                                                                        }
                                                                        onClick={() =>
                                                                            handleLunchGuestEditData(
                                                                                field.name,
                                                                                field.relationship,
                                                                                idx
                                                                            )
                                                                        }
                                                                    />
                                                                </Box>
                                                            )}
                                                        {idx !== 0 &&
                                                            props.modPermission !==
                                                            VIEW_PERMISSION && (
                                                                <Box
                                                                    sx={{
                                                                        display:
                                                                            'flex',
                                                                        alignItems:
                                                                            'center',
                                                                        flex: 0.05,
                                                                    }}>
                                                                    <Box
                                                                        component="img"
                                                                        className={
                                                                            classes.sedanBlack
                                                                        }
                                                                        alt="logo."
                                                                        src={
                                                                            trash
                                                                        }
                                                                        onClick={() =>
                                                                            handleRemoveLunchGuest(
                                                                                idx
                                                                            )
                                                                        }
                                                                    />
                                                                </Box>
                                                            )}
                                                    </Box>
                                                </Box>
                                            );
                                        })}
                            </Grid>
                        </Grid>
                    )}
                    {/* <Grid sx={{ padding: 0 }}>
                    <AppBar position="static" color="default" sx={appBarStyle}>
                        <Title
                            title={'HEALTH RELATED INFORMATION'}
                            // addicon="land"
                            sx={{
                                ml: 1,
                            }}
                        />
                    </AppBar>


                </Grid>
                <Grid sx={{ padding: '16px 0' }}>
                    <Grid px={2}>

                        <ListItem>
                            Prior to attending the 2022 NBA Draft Combine or G League Elite Camp, all players must document their vaccination status with the NBA
                            by completing this survey via the link below. Please contact the NBA with any questions.

                        </ListItem>
                        <Link sx={{ pl: 2 }} variant='body2' target='_blank' href="https://tmbo.iad1.qualtrics.com/jfe/form/SV_0O0EGK0hNcNw33g">https://tmbo.iad1.qualtrics.com/jfe/form/SV_0O0EGK0hNcNw33g</Link>


                    </Grid>
                </Grid> */}
                    {checkEditPermission ? (
                        <>
                            <Divider
                                light={false}
                                sx={{
                                    mt: 2,
                                    marginRight: 0,
                                    mb: 2,
                                    background: 'blue',
                                }}
                                flexItem
                            />
                            <Stack
                                spacing={2}
                                direction="row-reverse"
                                sx={{ m: 1 }}>
                                <Button
                                    variant="contained"
                                    onClick={handleClick}
                                    disabled={state.isDisable.get() ? true :
                                        loading.get() ||
                                            eventInfo.readonlyOrHide === 1
                                            ? eventRole !==
                                                AppConstants.EVENT_ROLES[0]
                                                ? userInfo.userType !==
                                                    AppConstants.USER_TYPES[0]
                                                    ? true
                                                    : state.addedFor.get() > 0
                                                        ? disableBtn
                                                        : false
                                                : state.addedFor.get() > 0
                                                    ? disableBtn
                                                    : false
                                            : state.addedFor.get() > 0
                                                ? disableBtn
                                                : false
                                    }>
                                    {state.addedFor.get() > 0
                                        ? 'Update'
                                        : 'Submit'}
                                </Button>
                                {props.showCancel ? (
                                    <Button
                                        variant="outlined"
                                        onClick={handleCancelReq}>
                                        Cancel
                                    </Button>
                                ) : null}
                            </Stack>
                        </>
                    ) : null}
                </Box>
                {/* </Paper> */}
                {/* </Paper> */}
                {openGuestDialog.get() && (
                    <AddGuest
                        open={openGuestDialog.get()}
                        title={
                            stateGuestObj.get() ? 'Update Guest' : 'Add Guest'
                        }
                        handleClose={handleAddGuestClose}
                        handleAction={handleGuestAction}
                        data={stateGuestObj.get()}
                    />
                )}
                {openLunchGuestDialog.get() && (
                    <AddGuest
                        open={openLunchGuestDialog.get()}
                        title={
                            stateLunchGuestObj.get()
                                ? 'Update Guest'
                                : 'Add Guest'
                        }
                        handleClose={handleAddLunchGuestClose}
                        handleAction={handleLunchGuestAction}
                        data={stateLunchGuestObj.get()}
                    />
                )}
                {snackBarProps.openSnack && (
                    <CustomizedSnackbars
                        {...snackBarProps}
                        onClose={() =>
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: false,
                            })
                        }></CustomizedSnackbars>
                )}
                <RouterPrompt
                    when={dirty.get()}
                    title="Leave this page"
                    cancelText="Cancel"
                    okText="Confirm"
                    onOK={() => true}
                    onCancel={() => false}
                />
            </Box>
        </Box>
    );
};

export default DraftRegistration;
